<template>
  <section class="min-h-screen bg-[#120F14] flex flex-col items-center justify-center px-4 relative overflow-hidden">
    
    <!-- Animated Background Glow Orbs -->
    <div class="absolute top-[10%] left-[10%] w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-[#00F0FF]/15 rounded-full blur-[100px] mix-blend-screen animate-float-slow pointer-events-none"></div>
    <div class="absolute bottom-[10%] right-[10%] w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-[#A144F6]/10 rounded-full blur-[120px] mix-blend-screen animate-float-delayed pointer-events-none"></div>
    <div class="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-[#BEFF2E]/10 rounded-full blur-[90px] mix-blend-screen animate-float-fast pointer-events-none"></div>

    <!-- Subtle Grid Overlay -->
    <div class="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_20%,transparent_100%)]"></div>

    <!-- Modern Revamp Logo -->
    <div class="relative z-10 animate-fade-in-up">
      <img
        loading="lazy"
        src="@/assets/revamp/logo2.webp"
        class="w-[200px] md:w-[250px] mb-12 hover:scale-105 transition-transform duration-500"
        alt="Maherco Logo"
      />
    </div>

    <!-- Error Box -->
    <div
      class="relative z-10 bg-[#14181F]/80 backdrop-blur-xl border border-[#00F0FF]/20 shadow-[0_0_50px_rgba(0,240,255,0.1)] rounded-[16px] p-8 md:p-10 w-full max-w-lg text-white text-center"
    >
      <h1 class="text-2xl md:text-3xl font-black mb-4 tracking-wider uppercase text-[#00F0FF] animate-pulse">
        Something went wrong
      </h1>
      <p class="text-base md:text-lg text-gray-400 leading-relaxed mb-8">
        {{ customError || defaultError }}
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
        <router-link
          to="/"
          class="w-full sm:w-auto bg-[#00F0FF] hover:bg-[#1ED6FF] text-black font-black uppercase tracking-widest text-sm py-4 px-8 rounded-xl transition-all shadow-[0_0_15px_#00F0FF20] hover:shadow-[0_0_25px_#00F0FF40] hover:-translate-y-1"
        >
          Back to Home
        </router-link>
        
        <a
          v-if="isMyrtleError"
          href="https://discord.com/invite/N764VWuGyn"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full sm:w-auto bg-[#5865F2] hover:bg-[#4752C4] text-white font-black uppercase tracking-widest text-sm py-4 px-8 rounded-xl transition-all shadow-[0_0_15px_#5865F220] hover:shadow-[0_0_25px_#5865F240] hover:-translate-y-1"
        >
          Join Discord
        </a>
        <a
          v-else
          href="https://kick.com/maherco"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full sm:w-auto bg-[#53FC18] hover:bg-[#45D112] text-black font-black uppercase tracking-widest text-sm py-4 px-8 rounded-xl transition-all shadow-[0_0_15px_#53FC1820] hover:shadow-[0_0_25px_#53FC1840] hover:-translate-y-1"
        >
          Go to Kick
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    customError() {
      return this.$route.query.error ? decodeURIComponent(this.$route.query.error) : null;
    },
    isMyrtleError() {
      return (
        this.customError ===
        "No associated MyrtleBot Kick account found. Please register first."
      );
    },
    defaultError() {
      return "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.";
    },
  },
};
</script>

<style scoped>
@keyframes float {
  0% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(30px, -50px) scale(1.1); }
  66% { transform: translate(-20px, 20px) scale(0.9); }
  100% { transform: translate(0, 0) scale(1); }
}

.animate-float-slow {
  animation: float 15s ease-in-out infinite;
}

.animate-float-delayed {
  animation: float 18s ease-in-out infinite;
  animation-delay: -7s;
}

.animate-float-fast {
  animation: float 12s ease-in-out infinite;
  animation-delay: -3s;
}

@keyframes fade-in-up {
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
}

.animate-fade-in-up {
  animation: fade-in-up 0.8s ease-out forwards;
}
</style>
